export default __webpack_public_path__ + "static/media/On.74653cb7.svg";